
import React, { useEffect } from 'react'
import { DeleteForever, Edit } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from 'hooks/useToggle';
import RegularButton from 'components/CustomButtons/Button';
import { blue, green, red, yellow } from '@mui/material/colors';
import { ModalV2 } from 'components/Modal/ModalV2';
import { AddCarburetion } from './AddCarburetion';
import {
  deleteCarburetion,
  updateCarburetionDate,
} from 'redux/actions/carburetions/carburetionAction';
import { printFillingOrderTicket } from 'redux/actions/fillingOrder/fillingOrderActions';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PrintIcon from '@mui/icons-material/Print';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import { animations } from 'helpers/animations';
import { formatNumber } from 'helpers/getNumberFormats';
import { UpdateDateComponent } from 'components/Dates/UpdateDateComponent';
import { useForm } from 'hooks/useForm';
import { formatCustomDate, newDate } from 'helpers/dateTools';
import {
  checkInventoryIsOpen,
  OPERATION_INVENTORY_CLOSED_MESSAGE,
} from 'hooks/fetch-hooks/useCheckInventoryStatus';
import WarningIcon from '@material-ui/icons/Warning';
import { useSearch } from "hooks/useSearch";
import { maskOrderValue } from '../../helpers/maskOrders';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { PERMISSIONS } from 'router/permissions';
import { useRuleValidator } from 'hooks/useRuleValidator';

const red1 = red[500];
const yellow1 = yellow[800];
const blue1 = blue[500];
const blue2 = blue[300];
const blue3 = blue[100];

const customStyle = {
  style: {
    textAlign: "center"
  }
}

const { CARBURATION_UPDATE_DATE, CARBURATIONS_FILLING_ORDER_VISIBLE } = PERMISSIONS;

const columns = [
  {
    Header: 'Unidad',
    accessor: 'unitNumber',
    filterable: true,
    filterMethod: (filter, row) =>
      row.unitNumber
        ? row.unitNumber.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: 'Folio',
    accessor: 'folio',
    filterable: true,
    filterMethod: (filter, row) =>
      row.folio
        ? String(row.folio).includes(filter.value)
        : "",
  },
  {
    Header: 'Orden',
    accessor: 'order',
    filterable: true,
    filterMethod: (filter, row) =>
      row.order
        ? row.order.toLowerCase().includes(filter.value.toLowerCase())
        : "",
    Cell: ({ original }) => {
      const canViewFillingOrder = useRuleValidator(CARBURATIONS_FILLING_ORDER_VISIBLE);
      const { unitConfigs } = useSelector(({ carburations }) => carburations);
      const { idUnit, order } = original;
      return <span>
        {
          canViewFillingOrder
            ? order
            : maskOrderValue({ unitConfigs, unitId: idUnit, orderValue: order })
        }
      </span>;
    }
  },
  {
    Header: 'Tipo carburación',
    filterable: true,
    accessor: 'type',
    filterMethod: (filter, row) =>
      row.type
        ? row.type.toLowerCase().includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: 'Km. Inicial',
    accessor: 'initialMileage',
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.initialMileage)
        ? String(row.initialMileage).includes(filter.value)
        : "",
    Cell: ({ original }) => {
      return <div>{formatNumber(original.initialMileage, "km")}</div>
    }

  },
  {
    Header: 'Km. Final',
    accessor: 'finalMileage',
    filterable: true,
    filterMethod: (filter, row) => String(row.finalMileage).toLowerCase().includes(filter.value),
    Cell: ({ original }) => {
      return <div>{formatNumber(original.finalMileage, "km")}</div>
    }

  },
  {
    Header: 'Carburación',
    filterable: true,
    accessor: 'carburation',
    filterMethod: (filter, row) => String(row.carburation).toLowerCase().includes(filter.value),
    Cell: ({ original }) => {
      return <div>{formatNumber(original.carburation, "lt")}</div>
    }
  },
  {
    Header: 'Consumo real',
    filterable: true,
    accessor: 'chargedVolumeStatus',
    filterMethod: (filter, row) => row.chargedVolumeStatus?.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => {
      return <span>
        {
          original.chargedVolumeStatus
            ? formatNumber(original.chargedVolumeStatus, "lt")
            : "Pendiente"
        }
      </span>;
    }
  },  
  {
    Header: 'SGC Envio',
    accessor: 'sgc',
    filterable: true,
    filterMethod: (filter, row) => row?.sgc.toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) => {
      return <div>{original?.sgc}</div>
    }
  },
  {
    Header: 'Fecha',
    accessor: 'date',
    filterable: true,
    filterMethod: (filter, row) => String(row?.date).toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: 'Acciones',
    filterable: false,
    Cell: ({ original }) => {
      const { config } = useSelector(({ login }) => login);
      const isUpdateDate = useRuleValidator(CARBURATION_UPDATE_DATE);
      const canViewFillingOrder = useRuleValidator(CARBURATIONS_FILLING_ORDER_VISIBLE);

      const { setSnackbar } = useSearch();
      const { unitNumber, fillingOrder, id, folio, date: orderDate, idUnit, order } = original
      const dispatch = useDispatch()
      const { isLoadingComp } = useSelector(({ search }) => search)
      const { station } = useSelector(({ carburations }) => carburations)
      const [openEdit, setOpenEdit] = useToggle()
      const [openDel, setOpenDel] = useToggle()
      const [loading, setLoading] = useToggle()
      const [loadingPrint, setLoadingPrint] = useToggle()
      const [openDate, setOpenDate] = useToggle()
      const [checkingInv, _ci, setCheckingInv] = useToggle()

      const { inputValues: { date }, handleInputOnChange, handleNewValues} = useForm({ date: newDate() })

      const handleDelete = async () => {
        if (checkingInv) return
        if (!station?.id) {
          setSnackbar("Seleccione una Planta", "danger", "tc")
          return
        }
        setCheckingInv(true)
        try {
          const isOpen = await checkInventoryIsOpen(station.id, formatCustomDate(orderDate, '-'))
          if (!isOpen) {
            setSnackbar(OPERATION_INVENTORY_CLOSED_MESSAGE, "danger", "tc")
            return
          }
        } catch (err) {
          setSnackbar(`${err || 'Error al consultar el inventario'}`, "danger", "tc")
          return
        } finally {
          setCheckingInv(false)
        }

        dispatch(deleteCarburetion(original.id, setOpenDel));
      }

      const handleTicket = async (toPrint = false) => {
        toPrint ? setLoadingPrint() : setLoading();
        await dispatch(printFillingOrderTicket({
          date: orderDate,
          unit: unitNumber,
          unitId: idUnit,
          orders: [{ ...fillingOrder, numberOrderExtra: order }],
          download: config?.printer,
          action: null,
          folio,
          selectUnitConfigs: (state) => state.carburations.unitConfigs,
          skipMasking: canViewFillingOrder,
        }));
      }

      const handleUpdateDateCarburetion = () => {
        const form = {
          idStation: station.id,
          date
        }
        dispatch(updateCarburetionDate(id, form, setOpenDate))
      }

      const handleWarning = () => {
        dispatch(setSnackbar(`UNIDAD ${unitNumber} EN MANTENIMIENTO, CONTACTA A SOPORTE EN CASO DE SER NECESARIO`))
      }

      useEffect(() => {
        let timer = setTimeout(() => {
          loading && setLoading()
        }, 2000);
        return () => {
          clearTimeout(timer)
        }
      }, [loading])

      useEffect(() => {
        let timer = setTimeout(() => {
          loadingPrint && setLoadingPrint()
        }, 5000);
        return () => {
          clearTimeout(timer)
        }
      }, [loadingPrint])
      return (
        <>
          <Box style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8
          }}>
            {
              original.fillingOrder?.id !== null ||  original?.chargedVolume === null &&
              <RegularButton
                justIcon
                round
                color="transparent"
                tooltip="Editar"
                onClick={setOpenEdit}
                size="sm"
                disabled={original?.isMaintenance}
              >
                <Edit style={{ color: blue1 }} />
              </RegularButton>
            }
            {
              isUpdateDate &&
              <RegularButton
                justIcon
                round
                color="transparent"
                onClick={setOpenDate}
                disabled={isLoadingComp?.loadingCarburetionActions}
                tooltip="Cambiar fecha"
              >
                <DateRangeIcon style={{ color: blue[600] }} />
              </RegularButton>
            }
            <RegularButton
              justIcon
              round
              color="transparent"
              tooltip="Eliminar"
              onClick={setOpenDel}
              size="sm"
              disabled={original?.isMaintenance}
            >
              <DeleteForever style={{ color: red1 }} />
            </RegularButton>
            {
              fillingOrder?.id &&
              <>
                <RegularButton
                  size="sm"
                  round
                  justIcon
                  color="transparent"
                  onClick={() => handleTicket()}
                  tooltip="Consultar Ticket"
                  loading={loading}
                >
                  <ConfirmationNumberIcon style={{ color: green[500] }} />
                </RegularButton>
                <RegularButton
                  size="sm"
                  round
                  justIcon
                  color="transparent"
                  onClick={loadingPrint ? null : () => handleTicket(true)}
                  tooltip={loadingPrint ? "Imprimiendo..." : "Imprimir"}
                >
                  {
                    loadingPrint ?
                      <HourglassFullIcon className={animations.rotate} style={{
                        color: loadingPrint ? blue3 : blue1,
                        animationIterationCount: 'infinite'
                      }} />
                      :
                      <PrintIcon style={{ color: loadingPrint ? blue2 : blue1 }} />
                  }
                </RegularButton>
              </>
            }

            {
              original?.isMaintenance &&
              <RegularButton
                round
                justIcon
                color="transparent"
                tooltip="En Mantenimiento"
                onClick={handleWarning}
                size="sm"
              >
                <WarningIcon style={{ color: yellow1 }} />
              </RegularButton>
            }

          </Box>
          <ModalV2
            title="Editar carburación"
            open={openEdit}
            onClose={setOpenEdit}
            toRight
          >
            <AddCarburetion data={original} onClose={setOpenEdit} isEdit />
          </ModalV2>
          <ModalV2
            title="¿Eliminar carburación?"
            open={openDel}
            onClose={setOpenDel}
            justConfirm
          >
            <RegularButton
              color="danger"
              fullWidth
              onClick={handleDelete}
            >
              Eliminar
            </RegularButton>
            <RegularButton
              color="transparent"
              fullWidth
              onClick={setOpenDel}
            >
              Cancelar
            </RegularButton>
          </ModalV2>
          <ModalV2
            title="Cambiar fecha de carburación"
            open={openDate}
            onClose={setOpenDate}
            justConfirm
            onSubmit={handleUpdateDateCarburetion}
            isLoading={isLoadingComp?.loadingCarburetionActions}
          >
            <UpdateDateComponent currentDate={original?.date} date={date} onChange={handleInputOnChange} onChange2={handleNewValues}/>
          </ModalV2>
        </>

      )
    }
  },
].map(item => {
  return {
    ...item,
    ...customStyle
  }
})

export { columns };